/**
 * WP 2FA Redirect Handler
 * 
 * Minimal script to handle AJAX login redirects for 2FA challenges.
 * Replaces the complex 1000+ line 2FA form management with simple redirect logic.
 * 
 * @package uncanny-learndash-toolkit
 * @since 1.0.0
 */

/**
 * Simple AJAX redirect handler for 2FA
 * 
 * Handles the response from AJAX login attempts and redirects to 2FA challenge
 * when required. All 2FA form rendering and validation is now handled server-side.
 */
class UltimateLogin2FARedirect {

    /**
 * Handles AJAX login response and performs redirect if 2FA is required
 * 
 * @param {Object} response - The AJAX login response
 * @returns {boolean} - True if redirect was handled, false otherwise
 */
    static handleResponse(response) {
        // Check if this is a 2FA redirect response
        if (response &&
            response.data &&
            response.data.requires_redirect === true &&
            response.data.redirect_url) {

            // Redirect to the 2FA challenge page
            if (typeof window !== 'undefined' && window.location) {
                window.location.href = response.data.redirect_url;
                return true;
            }
        }

        return false;
    }
}

// Make globally available for the frontend login system
if (typeof window !== 'undefined') {
    window.UltimateLogin2FARedirect = UltimateLogin2FARedirect;
}

// Export for module systems
if (typeof module !== 'undefined' && module.exports) {
    module.exports = UltimateLogin2FARedirect;
}
